import React from 'react'

import styles from './styles.css'

export default function Errored() {
  return <div className={styles.Errored}>Error!</div>
}
